var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeedbackDialog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.875 22.775V17.25q-2.575-.2-4.35-2.113-1.775-1.912-1.775-4.562 0-2.8 1.9-4.738Q5.55 3.9 8.325 3.875h.55L7.425 2.4l1.6-1.575L13.225 5l-4.2 4.2-1.6-1.6 1.45-1.45h-.55Q6.5 6.175 5.263 7.463 4.025 8.75 4.025 10.575q0 1.825 1.275 3.125T8.375 15h1.65v2.5L12.55 15h3.075q1.8 0 3.075-1.3 1.275-1.3 1.275-3.125 0-1.85-1.275-3.138-1.275-1.287-3.075-1.287H15.2V3.875h.425q2.775 0 4.7 1.95 1.925 1.95 1.925 4.75t-1.925 4.75q-1.925 1.95-4.7 1.95H13.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackDialog);
export default __webpack_public_path__ + "static/media/feedback_dialog.b45897783b49c34ffa08480ca56dc346.svg";
export { ForwardRef as ReactComponent };